import {NinchatErrorType} from 'api/types/errors'
import {NinchatProperties} from 'api/types'
import React from 'react'
import {SidebarTranscriptProps} from './types'
import SidebarTranscriptView from './SidebarTranscriptView'
import {navigation} from 'navigation'
import {setTranscriptStatus} from 'api/action/setTranscriptStatus'
import {toast} from 'components/Toast'
import {useAppDispatch} from 'hooks'
import {useTranslation} from 'react-i18next'
import {useUnassignTranscript} from 'hooks/transcripts/shared/useUnassignTranscript'

const SidebarTranscript = (props: SidebarTranscriptProps): React.ReactElement => {
    const {
        parentQueueSettings,
        transcript,
    } = props

    const dispatch = useAppDispatch()

    const {t} = useTranslation()
    const {unassignTranscript} = useUnassignTranscript()

    const loadTranscript = (): void => {
        navigation.push('RegisteredAudience', {
            audience_id: transcript.audience_id,
            queue_id: transcript.queue_id,
            registered: true,
        })
    }

    const onMarkTranscriptAsDone = (_audienceId: NinchatProperties.AudienceID) => dispatch(setTranscriptStatus({
        audience_id: _audienceId,
        transcript_status: 'done',
    }))
        .unwrap()
        .then(() => {
            toast.success('Marked as done')
        }, (error) => {
            let errorMessage = t('Error marking ticket done')

            switch (error.error_type) {
                case NinchatErrorType.NinchatPermissionDeniedError:
                    switch (error.error_reason) {
                        case 'User is not a realm operator':
                            errorMessage = t('You don\'t have permissions to mark tickets done on behalf of another user')
                            break
                        default:
                    }
                    break
                default:
            }
            toast.error(errorMessage)
        })

    // TODO: determining route based in route params only is a fragile approach
    const isSelected = history.state?.route?.params?.queue_id === transcript.queue_id &&
        history.state?.route?.params?.audience_id === transcript.audience_id

    return (
        <SidebarTranscriptView
            isSelected={isSelected}
            loadTranscript={loadTranscript}
            onMarkTranscriptAsDone={onMarkTranscriptAsDone}
            onUnassignTranscript={unassignTranscript}
            parentQueueSettings={parentQueueSettings}
            transcript={transcript}
        />
    )
}

export default SidebarTranscript
